<template>
  <div class="chat-area">
    <v-card class="pa-4 d-flex align-center chat-bubble">
      <v-icon color="primary" class="mr-2">mdi-robot</v-icon>
      <PremiumFeatureIcon message="Using AI Chatbot interface is a premium feature you will eventually have access to, but in the future it may require a premium account." />
      <div>
        <div class="font-weight-bold ">Ask AI</div>
        <div class="text-caption text-grey-darken-1 mt-1">Example: "How can I improve the health of my SPS corals?"</div>
      </div>
    </v-card>
  </div>
</template>

<script>
import PremiumFeatureIcon from '@/components/PremiumFeatureIcon.vue';
export default {
  name: 'ChatArea',
  components: {
      PremiumFeatureIcon,
  }
};
</script>

<style scoped>
.chat-area {
  margin-top: 24px;
  border: 1px solid rgb(var(--v-theme-surface));
  border-radius: 16px;
}
.chat-bubble {
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  cursor: pointer;
  transition: box-shadow 0.2s;
}
.chat-bubble:hover {
  background: rgb(var(--v-theme-lightSurface));
  box-shadow: 0 4px 16px rgba(0,0,0,0.2);
}
</style>
